// @flow

import styled from '@emotion/styled'
import * as React from 'react'

import { colors } from '@toggl/style'
import { Button } from '@toggl/ui'

import * as text from '../text'

type Props = {
  className?: string,
  title: React.Node | string,
  titleSize?: 1 | 2,
  subTitle?: React.Node,
  cta?: React.Node,
  titleColor?: string,
  align?: string,
  subText?: string,
}

export const ContainerSectionTitle = ({
  className,
  cta,
  title,
  titleColor,
  titleSize = 1,
  subTitle,
  subText,
  align,
}: Props) => {
  const Header = titleSize === 1 ? H2 : H3
  const isTitleText = typeof title === 'string'
  return (
    <Root align={align} className={className} cta={!!cta}>
      {subText && (
        <text.UppercaseOneLiner color={colors.darkPurple70}>
          {subText}
        </text.UppercaseOneLiner>
      )}
      {isTitleText ? <Header headingColor={titleColor}>{title}</Header> : title}
      {subTitle}
      {cta && <CtaBox align={align}>{cta}</CtaBox>}
    </Root>
  )
}

export const Root: React.ComponentType<any> = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 800px;
  text-align: ${(p) => p.align || 'center'};
  margin-bottom: ${(p) => (p.cta ? '60px' : '40px')};

  p {
    max-width: 650px;
  }

  ${(p) =>
    p.align !== 'left' &&
    `
      margin-left: auto;
      margin-right: auto;

      p {
        margin-left: auto;
        margin-right: auto;
      }
      `};
`

const H2 = styled(text.H2)`
  color: ${(p) => p.headingColor || p.theme.primary};
`
const H3 = styled(text.H3)`
  color: ${(p) => p.headingColor || p.theme.primary};
`

const CtaBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  align-items: center;
  ${(p) =>
    p.align === 'left'
      ? `justify-content: flex-start`
      : `justify-content: center`};
  margin-top: 15px;
  ${Button.Primary}, ${Button.Alternate}, button {
    display: inline-flex;
  }
`
